var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlitterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 40,
    viewBox: "0 0 152 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.584 1.54248H51.6642V38.4221H43.584V1.54248Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3146 11.6969H56.2344V38.426H64.3146V11.6969Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.11 17.6004V11.697H94.9833V3.77051H86.9031V11.697H83.7562H82.9162H78.6296V3.77051H70.5494V11.697H66.5625V17.6004H70.5494V30.9649C70.5494 36.4543 73.3453 38.6311 80.0296 38.6311C81.2205 38.6311 82.5179 38.5798 83.7601 38.4221V32.4161H81.6898C79.6194 32.4161 78.6336 32.0533 78.6336 30.0855V17.6004H82.9202H83.7601H86.907V30.9649C86.907 36.4543 89.703 38.6311 96.3872 38.6311C97.5782 38.6311 98.8756 38.5798 100.118 38.4221V32.4161H98.0474C95.9771 32.4161 94.9912 32.0533 94.9912 30.0855V17.6004H100.11Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M127.817 30.2867L108.474 26.1263C108.226 29.9948 110.174 32.2663 113.262 32.9327C115.896 33.5006 117.844 32.8066 119.161 31.1306L126.654 32.7435C124.047 37.9568 118.286 40.1099 112.008 38.7573C103.904 37.0143 99.5896 30.4681 101.38 22.163C103.155 13.9093 109.638 9.63451 117.793 11.3894C125.944 13.1442 130.053 19.9073 128.156 28.7211L127.817 30.2867ZM109.602 21.1219L121.149 23.6064C121.291 20.2465 119.627 17.8764 116.436 17.1863C113.55 16.5672 110.994 17.6083 109.602 21.1219Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M148.643 11.3854V18.74H146.573C142.066 18.74 139.479 20.9681 139.479 25.9921V38.4221H131.398V11.6969H139.274V16.6697C140.413 13.3532 142.898 11.2828 146.889 11.2828C147.504 11.2828 148.072 11.3341 148.643 11.3854Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0623 17.8606H23.0737V24.6986H31.2564C30.6334 28.9458 26.958 31.6905 22.4506 31.6905C16.3421 31.6905 12.4025 27.0174 12.4025 19.9822C12.4025 13.1481 16.4091 8.27393 22.0365 8.27393C26.1693 8.27393 29.6002 10.4507 30.6334 13.9723H39.593C38.406 5.78952 30.9015 0.714233 21.9853 0.714233C10.9868 0.714233 3.28516 8.90884 3.28516 19.9822C3.28516 31.3553 11.1485 39.2541 20.9481 39.2541C21.236 39.2541 21.5199 39.2659 21.7999 39.2857C27.0172 39.2857 40.0623 38.0908 40.0623 17.8606Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3066 1.53064H56.2422V9.31118H64.3066V1.53064Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlitterLogo);
export default __webpack_public_path__ + "static/media/glitter-logo.42bf2467983f5cda6274d454f238d695.svg";
export { ForwardRef as ReactComponent };